import { MediaSourceType } from '../../types';
export function getTransKeyForMediaSourceType(mediaSource) {
    var _a;
    if (mediaSource === void 0) { mediaSource = MediaSourceType.COLLECTION; }
    var mediaSourceTypeToLabelMap = (_a = {},
        _a[MediaSourceType.GALLERY] = 'mediapopup.myGalleries',
        _a[MediaSourceType.COLLECTION] = 'mediapopup.myCollections',
        _a[MediaSourceType.STASH] = 'mediapopup.myStash',
        _a[MediaSourceType.BROWSE] = 'mediapopup.browse',
        _a[MediaSourceType.POLL] = 'mediapopup.myPolls',
        _a[MediaSourceType.STATUS] = 'mediapopup.myStatuses',
        _a[MediaSourceType.JOURNAL] = 'mediapopup.myJournals',
        _a[MediaSourceType.POSTS] = 'mediapopup.myPosts',
        _a[MediaSourceType.TIER] = 'mediapopup.tiers',
        _a[MediaSourceType.TIER_DEVIATIONS] = 'mediapopup.tierDeviations',
        _a[MediaSourceType.TIER_POSTS] = 'mediapopup.tierPosts',
        _a);
    return mediaSourceTypeToLabelMap[mediaSource];
}
export function getAllMediaSourceTypes() {
    return [
        MediaSourceType.GALLERY,
        MediaSourceType.COLLECTION,
        MediaSourceType.STASH,
        MediaSourceType.BROWSE,
        MediaSourceType.POLL,
        MediaSourceType.STATUS,
        MediaSourceType.JOURNAL,
        MediaSourceType.POSTS,
    ];
}
//# sourceMappingURL=_helpers.js.map